import { render } from "./ShowTutorial.vue?vue&type=template&id=4c7b4c66&scoped=true"
import script from "./ShowTutorial.vue?vue&type=script&lang=js"
export * from "./ShowTutorial.vue?vue&type=script&lang=js"

import "./ShowTutorial.vue?vue&type=style&index=0&id=4c7b4c66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c7b4c66"]])

export default __exports__